import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalMessageService, GlobalMessageType } from "@spartacus/core";
import { Subscription } from "rxjs";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import { CustomCustomerServiceBrService } from "../custom-customer-service-br.service";

@Component({
    selector: 'app-create-new-ticket',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './create-new-ticket.component.html',
    styleUrls: ['./create-new-ticket.component.scss'],
    standalone: false
})
export class CreateNewTicketComponent implements OnInit,OnDestroy {
  ticketTypeList:any;
  selectedType: any;
  subTicketCategoryList:any;
  selectedTheme: any;
  selectedBU: any;
  imageError: string;
  filename=[];
  ticketCategoriesSub:Subscription;
  subTicketCategoriesSub:Subscription;
  userAccountDetailsSub:Subscription;
  ticketCreatedSub:Subscription;
  ticketCreationErrorSub:Subscription;
  getB2bUnitData:any;
  b2bUnitList:any;
  createTicketClicked=false;
  emailConsentChecked='false';
  ticketForm = new FormGroup({
    ticketType: new FormControl('', [Validators.required]),
    ticketTheme: new FormControl('', [Validators.required]),
    ticketBU: new FormControl('', [Validators.required]),
    ticketDesc: new FormControl('', [Validators.required]),
  });
  base64EncodedArray=[];
  uploadedFilesData=[];
  constructor(private readonly modalService: NgbModal,
    private readonly customerService:CustomCustomerServiceBrService,
    private readonly addToCartService: CustomAddToCartService,
    private readonly globalMessage: GlobalMessageService,
    private readonly sharedService: SharedService,
    private readonly sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.customerService.ticketCategories.subscribe((res:any)=>{
      if(res){
        this.ticketTypeList=res?.ticketCategories;
      }
    });
    this.customerService.subTicketCategories().subscribe((res:any)=>{
      if(res){
        this.subTicketCategoryList=res?.filter(item=>item.name!=null);
      }
    });
    this.userAccountDetailsSub=this.addToCartService.userAccountDetails.subscribe((userDataget) => {
      if (userDataget) {
        this.getB2bUnitData = userDataget?.res?.shippingAddresses?.filter(item=>item?.unitID===userDataget?.res?.uid);
        this.b2bUnitList=[];
        for(const b2bData of this.getB2bUnitData){
          const b2bUnitItem= {name:`${b2bData?.companyName} ${b2bData?.line1} ${b2bData?.town}`,id:`${b2bData?.unitID}`};
          this.b2bUnitList.push(b2bUnitItem);
        }
        if(this.b2bUnitList?.length===1){
          this.selectedBU=_.first(this.b2bUnitList);
        }
      }
    });
  }
  uploadFile(fileInput: any) {
    this.sharedService.fileChangeEvent(fileInput).subscribe((res)=>{
      if(res){
        this.uploadedFilesData.push(res);
      }
    });
  }
  removeUploadedFile(removedData){
    this.uploadedFilesData=this.sharedService.removeFile(this.uploadedFilesData,removedData);
  }
  close(): void {
    this.modalService.dismissAll();
  }
  emailCheck(checkedEvent):void{
    this.emailConsentChecked=checkedEvent?'true':'false';
  }
  createTicket():void{
    this.createTicketClicked=true;
    if(this.ticketForm?.valid){
      const params={ticketCategory:{id:this.ticketForm?.controls?.ticketType?.value},
      ticketSubType:this.ticketForm?.controls?.ticketTheme?.value,
      b2bUnitId: this.b2bUnitList?.length > 1 ? this.ticketForm?.controls?.ticketBU?.value : (this.ticketForm?.controls?.ticketBU as any)?.value?.id,
      description:this.ticketForm?.controls?.ticketDesc?.value,
      sendEmailConsent:this.emailConsentChecked,
      ticketAttachments:this.uploadedFilesData
    };
      this.customerService.createTicketDetails(params);
      this.ticketCreatedSub=this.customerService.ticketCreationError.subscribe((res:any)=>{
        if(res){
          this.modalService.dismissAll();
        }
      });
      this.ticketCreationErrorSub=this.customerService.ticketCreated.subscribe((res:any)=>{
        if(res){
          this.globalMessage.add(`Ticket ${res?.id} creado con exito!`,GlobalMessageType.MSG_TYPE_CONFIRMATION,5000000);
          this.modalService.dismissAll();
        }
      });
    }
  }
  ngOnDestroy(){
    this.ticketCategoriesSub?.unsubscribe();
    this.subTicketCategoriesSub?.unsubscribe();
    this.ticketCreatedSub?.unsubscribe();
    this.ticketCreationErrorSub?.unsubscribe();
  }
}
